import BaseIconSvg from '@/components/bases/BaseIconSvg';
import BaseImage from '@/components/bases/BaseImage';
import useActions from '@/hooks/useActions';
import useQueries from '@/hooks/useQueries';
import CreateEmr from '@/screens/CreateEmr';
import InfoCard from '@/screens/PHR/components/InfoSection/InfoCard';
import useAuth from '@/stores/auth';
import { useQuickModal } from '@/utils/quickModal';
import { Button, Segmented } from 'antd';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

export interface ITopBarProps {
  action?: boolean;
  backUrl?: string | boolean;
}

export default function TopBar({ action, backUrl }: ITopBarProps) {
  const navigate = useNavigate();
  const user = useAuth((s) => s.user);
  const [queries, setQueries] = useQueries();
  const logout = useAuth((s) => s.logout);
  const { quickModal, quickModalContext } = useQuickModal();
  const { isCMSView } = useActions();
  return (
    <div className="flex justify-between h-16 px-2">
      {quickModalContext}
      <div className="flex items-center w-[300px] flex-none">
        <div className="mr-2 h-full">
          {backUrl ? (
            <Button
              className="flex items-center h-full px-[2px] bg-white border-none rounded-r-none"
              onClick={() => (backUrl === true ? navigate(-1) : navigate('/'))}
            >
              <BaseIconSvg src="/icons/Light/Angle Left - icon.svg" />
            </Button>
          ) : null}
        </div>
        <BaseImage className="block cursor-pointer h-[30px]" src="/images/vclass-logo.png" onClick={() => navigate('/')} />
      </div>

      <div className="w-full h-full flex justify-between py-2">
        <div className="flex justify-between w-full px-2">
          {action ? (
            <>
              <Segmented
                value={queries.tab || 'list'}
                onChange={(key: string) => {
                  setQueries({ ...queries, tab: key });
                }}
                className="h-full [&_.ant-segmented-group]:h-full"
                options={[
                  {
                    className: 'h-full [&_.ant-segmented-item-label]:h-full',
                    value: 'list',
                    label: (
                      <div className="flex items-center h-full item-center">
                        <BaseIconSvg src={'/icons/Regular/Check list - icon.svg'} className="mr-2" />
                        Tổng hợp
                      </div>
                    ),
                  },
                  {
                    className: 'h-full [&_.ant-segmented-item-label]:h-full',
                    value: 'timeline',
                    label: (
                      <div className="flex items-center h-full item-center">
                        <BaseIconSvg src={'/icons/Regular/Process - icon.svg'} className="mr-2" />
                        Dòng thời gian
                      </div>
                    ),
                  },
                ]}
              />
              {!isCMSView && <CreateEmr />}
            </>
          ) : null}
        </div>
        {!isCMSView && (
          <div className="bg-gray-1 h-full rounded-lg flex flex-none gap-2 shadow overflow-hidden">
            <InfoCard user={user} />
            <Button
              className="h-full px-1 bg-white border-t-0 border-b-0 border-r-0 rounded-none shadow-none"
              onClick={() => {
                quickModal.confirm({
                  content: 'Bạn có Chắc chắn muốn đăng xuất?',
                  onOk: () => logout(),
                });
              }}
            >
              <BaseIconSvg src="/icons/Regular/Sign out - icon.svg" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
